import { Injectable} from '@angular/core';
import { environment } from '../../environments/environment';
import {StartDateTermData} from '../core/services/header-footer.service'
import { formatDate } from '@angular/common';

export const PAGE_NOT_FOUND_TEXT="!PAGE_NOT_FOUND!";
@Injectable({
    providedIn: 'root'
})
export class Constants {
    EncryptKey: string;
    countryCode: string;
    APIBasePath: string;
    APIBasePathContentFul: string;
    ContentFulAccessToken: string;
    ContentFulPreviewToken: string;
    APIRequestTimeout: number;
    ContentFulPreviewSecret: string;
    DefaultSiteConfigEntry: string;
    GenesysSrc: string
    GenesysPluginsPath: string;
    GenesysLoadFile: string;
    GenesysEnvironment: string;
    GenesysCdnUrl: string;
    YcbmSrc: string;
    YcbmPath: string;
    DefaultHomePage: string;
    PageNotFoundIndicatorText: string;
    IpStackEndPoint: string;
    SIFSourceID: string;
    SIFVendorID: string;
    PCSourceID: string;
    PCVendorID: string;
    SIFSourceIDInt: string;
    SIFVendorIDInt: string;
    environmentName:  string;
    domain: string;
    ReCaptchaPublicKey: string;
    ReCaptchaChallengePublicKey: string;
    SiteSearch360ConfigurationId: string;
    domainFilter: string;
    productionDomain: string;
    pglsDomain: string;
    pglsDomainUrl: string;
    blackListParams: string[];
    currentYear: string;
    defaultStartDateTermConfig: StartDateTermData[];
    dividerSVG: string;
    NinetailedClientId: string;
    NinetailedEnvironment: string;

    constructor() {
        this.EncryptKey = '##pg@law~Kap~2023##';
        this.countryCode = 'US';
        this.APIBasePath = environment.APIBasePath;
        this.APIBasePathContentFul = `${environment.Contentful.BasePath}${environment.Contentful.Space}${environment.Contentful.environment ? '/environments/' + environment.Contentful.environment : ''} `;
        this.APIRequestTimeout = 25000000;
        this.ContentFulAccessToken = environment.Contentful.AccessToken;
        this.ContentFulPreviewToken = environment.Contentful.PreviewToken;
        this.ContentFulPreviewSecret = 'wwwPurdueGlobalPreview';
        this.DefaultSiteConfigEntry = "3hG1CCByS1SRw6TeY2ZfmA";
        this.GenesysSrc = environment.Genesys.src;
        this.GenesysPluginsPath = environment.Genesys.pluginsPath;
        this.GenesysLoadFile = environment.Genesys.loadFile;
        this.GenesysEnvironment = environment.Genesys.env;
        this.GenesysCdnUrl = environment.Genesys.cdnUrl;
        this.YcbmSrc = environment.Ycbm.src;
        this.YcbmPath = environment.Ycbm.path;
        this.DefaultHomePage = '/';
        this.IpStackEndPoint = 'https://api.ipstack.com/check?access_key=2ac4553bc5dca2b31534a6c9c341ac0c&output=json&legacy=1';
        this.SIFSourceID = "302454";
        this.SIFVendorID = "60493";
        this.PCSourceID = "100036";
        this.PCVendorID = "60027";
        this.PageNotFoundIndicatorText= PAGE_NOT_FOUND_TEXT;
        this.environmentName = environment.name;
        this.ReCaptchaPublicKey = environment.Recaptcha.PublicKey;
        this.ReCaptchaChallengePublicKey = environment.Recaptcha.ChallengePublicKey;
        this.SiteSearch360ConfigurationId = environment.SiteSearch360.configurationId;
        this.NinetailedClientId = environment.Ninetailed.ClientId;
        this.NinetailedEnvironment = environment.Ninetailed.Environment;
        this.domain = environment.link;
        this.productionDomain = 'www.purdueglobal.edu';
        this.domainFilter = this.productionDomain;
        this.pglsDomain = 'www.purduegloballawschool.edu';
        this.pglsDomainUrl = 'https://www.purduegloballawschool.edu/';
        this.dividerSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="15" viewBox="0 0 16 15" fill="none">
            <mask id="mask0_18431_236" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="15">
            <path d="M15.5 15L15.5 0L0.500001 -6.55671e-07L0.5 15L15.5 15Z" fill="white"/>
            </mask>
            <g mask="url(#mask0_18431_236)">
            <path d="M15.5 0L0.500001 -6.55671e-07L8 15L15.5 0Z" fill="#333133"/>
            </g>
            </svg>`;

        // if any qsp has to be ignored from the persisted list add it to the below list
        this.blackListParams = [
            'q',
            'ctype',
            'aos',
            'zip',
            'country',
            'aoi',
            'chct',
            'chai',
            'cht',
            'l',
            'page',
            'pl',
            'aspxerrorpath',
            'isLogin',
            'qt',
            'a',
            'd',
            'returnUrl',
            'id',
            'programID',
            'discountRate',
            'areaOfStudy',
            'degreeLevelID',
            'purge',
            'purge-all',
            'branch',
            'skill',
            'mos',
            'branchId',
            'skillLevelId',
            'occupationCodeId'
          ];
        this.currentYear = formatDate(new Date(), 'yyyy', 'en_US');
        this.defaultStartDateTermConfig = [{
            from : `${this.currentYear}-01-01T00:00:00.000Z`,
            to : `${this.currentYear}-04-30T00:00:00.000Z`,
            term : 'Spring term'
        },
        {
            from : `${this.currentYear}-05-01T00:00:00.000Z`,
            to : `${this.currentYear}-07-31T00:00:00.000Z`,
            term : 'Summer term'
        },
        {
            from : `${this.currentYear}-08-01T00:00:00.000Z`,
            to : `${this.currentYear}-12-31T00:00:00.000Z`,
            term : 'Fall term'
        }
    ]
    }

}

// This value should match the content model
export enum ComponentType {
    ContentBlock = "ContentBlock",
    MultiColumn = "MultiColumn",
    FooterCta = "FooterCta",
    Quotes = "Quotes",
    HorizontalCallout = "HorizontalCallout",
    ContentBlockRR = "ContentBlockWithRightRailCallout",
    LargeTwoColumn = "Large2Column",
    StartDates = "StartDates",
    FaqAccordion = "FaqAccordion",
    HorizontalTabs = "HorizontalTabs",
    HorizontalTabContent = "HorizontalTabContent",
    VerticalTabs = "VerticalTabs",
    ProgramFinder = "ProgramFinder",
    ContentFinder = "ContentFinder",
    HorizontalProgramFinder = "HorizontalProgramFinder",
    HeroProgramFinder = "HeroProgramFinder",
    BigHero = "BigHero",
    CareerAssessment = "CareerAssessment",
    FacultyDirectory = "FacultyDirectory",
    FacultyListingContainer = "FacultyListingContainer",
    FaqItem = "Faq",
    Divider = "Divider",
    SifGenericForm = "SifGenericForm",
    Glance = "Glance",
    DynamicCBRR = "DynamicCbrr",
    CareerOpportunities = "CareerOpportunities",
    SubmenuCallout = "SubmenuCallout",
    StoriesContentBlock = "StoriesCb",
    TuitionReduction = "TuitionReduction",
    ProgramFinderHybride = "ProgramFinderHybride"
}

export enum ImageAlignment {
    Left = "Left",
    Right = "Right"
}

export enum Environments {
    Development = "development environment",
    Stage = "stage environment",
    Production = "production environment"
}

export enum AosQuestionTypes {
  RegisteredLicense = 'registeredLicense',
  // Note: Enum key and value retained as 'IsCLSDegree'/'isCLSDegree' for consistency across the codebase and to align with Contentful CMS field naming conventions (e.g., clsDegreeQuestion). The AOS code value is updated from "CLS" to "PGLS" in SIFCatalog.json.
  IsCLSDegree = 'isCLSDegree',
}

